import React from 'react';
import { DayCard } from './DayCard';
import type { DayActivityData } from '../utils/useActivityData';
import type { ActivityItem } from './ActivityList';

interface DaysScrollContainerProps {
    dayDataArray: DayActivityData[];
    selectedDatesCount: number;
    onActivityClick?: (activity: ActivityItem) => void;
}

export function DaysScrollContainer({
    dayDataArray,
    selectedDatesCount,
    onActivityClick
}: DaysScrollContainerProps) {
    return (
        <div className="flex gap-6 overflow-x-auto pb-4">
            {dayDataArray.map((dayData) => {
                const dateKey = dayData.date.toISOString().split('T')[0];
                return (
                    <DayCard
                        key={dateKey}
                        dayData={dayData}
                        isOnlyDay={selectedDatesCount === 1}
                        onActivityClick={onActivityClick}
                    />
                );
            })}
        </div>
    );
}
